__turbopack_context__.v({
  "className": "ibm_plex_mono_dfbfdcfc-module__4CoxZG__className",
  "variable": "ibm_plex_mono_dfbfdcfc-module__4CoxZG__variable",
});
